<template>
  <div class="search-container">
    <input
      type="text"
      v-model="searchQuery"
      @keyup.enter="searchProducts"
      placeholder="Rechercher un produit..."
      class="search-bar"
    />
    <i class="fas fa-search search-icon" @click="searchProducts"></i>
  </div>

  <div class="product-grid">
    <div 
      v-for="product in products" 
      :key="product._id" 
      class="product-item"
    >
      <img :src="product.image" alt="Produit" class="product-image" />
      <h3 class="product-name">{{ product.name }}</h3>
      <p class="product-price">{{ product.price }} DH</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProductsPage",
  data() {
    return {
      searchQuery: "",
      products: [],
    };
  },

  methods: {
    async searchProducts() {
      try {
        const res = await axios.get(
          `http://localhost:2028/api/products?search=${this.searchQuery}`
        );
        this.products = res.data;
      } catch (error) {
        console.error("Erreur lors de la recherche :", error);
      }
    },
    async getAllProducts() {
      try {
        const res = await axios.get("http://localhost:2028/api/products");
        this.products = res.data;
      } catch (error) {
        console.error("Erreur lors du chargement des produits :", error);
      }
    },
  },
  mounted() {
    this.getAllProducts();
  },
};
</script>
